import SimulationService from '@/services/simulation.service'

const state = {
    page: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    current: {},

    currentLoading: false,
    assortmentAnalysisLoading: false,
    assortmentAnalysis: {},

    approvalLoading: false
}

const getters = {}

const actions = {
    read: async ({ commit }, args) => {
        if (!args) args = {}
        if (!args.page) args.page = 1
        if (!args.limit) args.limit = 20
        if (state.page.index == args.page) return true
        try {
            let page = await SimulationService.read(args)
            commit('readSuccess', page.data, args.page)
            return page.data
        } catch (e) {
            if (e && e.response) throw e.response.status
            else throw 500
        }
    },

    readById: async ({ commit }, id) => {
        if (!id) return true

        try {
            let simulation = SimulationService.readById(id)

            commit('readingById')
            simulation = await simulation
            commit('readByIdSuccess', simulation.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readAssortmentAnalysisById: async ({ commit }, id) => {
        if (!id) return true

        try {
            let simulation = SimulationService.readAssortmentAnalysisById(id)

            commit('readingAssortmentAnalysisById')
            simulation = await simulation
            commit('readAssortmentAnalysisByIdSuccess', simulation.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    createClone: async ({ commit }, id) => {
        if (!id) return true
        try {
            let response = await SimulationService.createClone(id)

            commit('createCloneSuccess', response.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    removeClone: async ({ commit }, id) => {
        if (!id) return true
        try {
            await SimulationService.removeClone(id)

            commit('removeCloneSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    execute: async ({ commit }, args) => {
        if (!args.id) return
        try {
            await SimulationService.execute(args.id, args.observation)
            commit('executeSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    approve: async ({ commit }, args) => {
        if (!args.id) return
        try {
            let approve = SimulationService.approve(args.id, args.caveat)
            commit('approveLoadingSuccess')
            await approve
            commit('approveSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    canSimulate: async ({ commit }, args) => {
        try {
            const response = await SimulationService.canSimulate(args)
            commit('canSimulateSuccess', response.data)
            return response.data
        } catch (e) {
            if (e && e.response) throw e.response.status
            else throw 500
        }
    }
}

const mutations = {
    readSuccess(state, page, page_index) {
        state.page = page
        state.page.index = page_index
    },

    readingById(state) {
        state.currentLoading = true
    },

    readByIdSuccess(state, current) {
        state.currentLoading = false
        state.current = current
    },

    removeCloneSuccess(state) {
        state.current.clone = null
    },

    createCloneSuccess(state, data) {
        state.current.clone = data.clone_id
    },

    executeSuccess(state) {},

    readingAssortmentAnalysisById(state) {
        state.assortmentAnalysisLoading = true
    },
    readAssortmentAnalysisByIdSuccess(state, data) {
        state.assortmentAnalysis = data
        state.assortmentAnalysisLoading = false
    },
    approveLoadingSuccess(state) {
        state.approvalLoading = true
    },
    approveSuccess(state) {
        state.approvalLoading = false
    },

    canSimulateSuccess(state) {}
}

const simulations = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default simulations
export { simulations }
